import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { SearchParamEnum } from '../enums';
import { PaginationDetails } from '../interfaces';
import { UrlSearchParams, UseState } from '../types';

export const usePagination: (itemsPerPage?: number, withSearchParamsStateSave?: boolean) => PaginationDetails = (
  itemsPerPage: number = 10, withSearchParamsStateSave: boolean = false
): PaginationDetails => {
  const [maxItems, setMaxItems]: UseState<number> = useState<number>(0);
  const [page, setPage]: UseState<number> = useState<number>(1);
  const [searchParams, setSearchParams]: UrlSearchParams = useSearchParams();

  useEffect(
    (): void => {
      if (withSearchParamsStateSave
        && !!searchParams.get(SearchParamEnum.Page)
        && Number(searchParams.get(SearchParamEnum.Page)) !== page
      ) {
        setPage(Number(searchParams.get(SearchParamEnum.Page)));
      }
    },
    [searchParams]
  );

  const setPageMethod: (value: number) => void = (value: number) => {
    setPage(value);
    if (withSearchParamsStateSave) {
      searchParams.set(SearchParamEnum.Page, String(value));
      setSearchParams(searchParams);
    }
  };

  return {
    setMaxItems,
    setPage: setPageMethod,
    itemsPerPage,
    maxItems,
    offset: (page - 1) * itemsPerPage,
    page
  };
};
